import pluralize from 'pluralize'
import React, { useState } from 'react'
import Select from "react-select"

import Modal from "../reusable/modal"

import { roles, stores } from '../../permissions'

const EditPermissions = ({ toggle, visible, store, item, onPerform }) => {
    const [permissions, setPermissions] = useState(item?.subject?.permissions ?? [])

    const complete = () => {
        onPerform(item.i, permissions, item?.subject?.type)
        toggle()
    }

    let hasAll = permissions.some(prm => prm.label === '*')

    const toggleAssignAll = () => setPermissions(hasAll ? [] : [{ label: '*', value: '*' }])

    return (
        <Modal
            w={ 450 }
            title="Edit Permissions"
            toggle={toggle}
            visible={visible}>
            {
                item &&
                <Select
                    isMulti
                    isDisabled={ hasAll }
                    value={ hasAll ? [] : permissions }
                    onChange={ setPermissions }
                    options={ (store ? stores : roles[item?.subject?.value])?.map(role => ({ label: role, value: role })) ?? [] }
                    placeholder="Assign Permissions" />
            }
            <div className="flex justify-end mt-4">
                <button onClick={ toggleAssignAll } className="text-white mr-2 hisani-btn-orange-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ hasAll ? 'Revoke' : 'Assign All' }</button>
                <button onClick={ complete } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default EditPermissions